module.exports = __webpack_public_path__ + "12cfe7ae0d0935249b542f4adcbbf64a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/signature/signature-autumn-2012-page-002.jpg
 ** module id = 469
 ** module chunks = 0
 **/